<template>
  <Section id="business-section" class="business-usp">
    <div class="componata-container">
      <div class="business-usp__duo">
        <div class="business-usp__single">
          <SectionHeader textAlign="left">
            <template v-slot:title>Keine Mindestmengen, verschenken Sie 1 bis 9.000 Präsente</template>

            <template v-slot:description>
              <p>Componata ist Ihr Partner für edle Präsente, sowohl für die kleinen als auch die großen Ereignisse im Jahr. Dabei ist es egal ob sie einzelnen oder sehr vielen eine Freude machen wollen — bei uns ist jedes Präsent mit Liebe verpackt.</p>

              <Button size="large" @click="scrollTo('contact');">Kontakt aufnehmen</Button>
            </template>
          </SectionHeader>
        </div>

        <div class="business-usp__single">
          <SectionHeader textAlign="left">
            <template v-slot:title>Individuelle Versandmöglichkeiten</template>
          </SectionHeader>

          <ul class="business-usp__shipping-options">
            <li class="business-usp__shipping-option">
              <img src="@/assets/images/landing-page/icon-shipping-gift.svg" class="business-usp__shipping-icon">

              <div>
                <h4 class="business-usp__shipping-title">Direktversand an Beschenkte</h4>
                <p class="business-usp__shipping-description">Unabhängig von der Stückzahl ist ein direkter Versand an Mitarbeiter, Geschäftspartner und Kunden möglich. Unsere Präsente sind stets geschenkfertig.</p>
              </div>
            </li>

            <li class="business-usp__shipping-option">
              <img src="@/assets/images/landing-page/icon-shipping-box.svg" class="business-usp__shipping-icon">

              <div>
                <h4 class="business-usp__shipping-title">Großversand</h4>
                <p class="business-usp__shipping-description">Lassen Sie sich Ihre Bestellung geschlossen an eine oder mehrere Adresse schicken, bspw. für eine persönliche Übergabe vor Ort.</p>
              </div>
            </li>

            <li class="business-usp__shipping-option">
              <img src="@/assets/images/landing-page/icon-shipping-combined.svg" class="business-usp__shipping-icon">

              <div>
                <h4 class="business-usp__shipping-title">Flexible Kombinationsmöglichkeiten</h4>
                <p class="business-usp__shipping-description">Entscheiden Sie für Ihren Anwendungsfall individuell welche Präsente an welche Lieferadressen versendet werden..</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </Section>
</template>

<script>
import { UiMixin } from '@/mixins/UiMixin';

import Section from '@/components/PresentPage/Section';
import SectionHeader from '@/components/PresentPage/SectionHeader';
import Button from '@/components/Common/Button';

export default {
  name: 'BusinessUsp',
  mixins: [UiMixin],
  components: {
    Section,
    SectionHeader,
    Button
  }
};
</script>

<style lang="scss" scoped>
/**
 * Business USP
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Business Unique Selling Points
 * @since 2021-02-01
**/

$component: 'business-usp';

.#{$component} {
  // min-height: 100vh;
  padding-bottom: 0 !important;
  background: linear-gradient(90deg, $aqua 50%, $yellow 50%);
  background-size: 100%;
  z-index: 0;

  &:after {
    content: '';
    display: block;
    width: 100%;
    height: 34rem;
    @include margin-top(- map-get($spacers, 6) * 2);
    background: url('~@/assets/images/landing-page/bgr-cardboard-boxes@1x.png') center top no-repeat;
    background-size: cover;
    pointer-events: none;
    z-index: 0;

    @include retina {
      background: url('~@/assets/images/landing-page/bgr-cardboard-boxes@2x.png') center top no-repeat;
    }
  }

  &__duo {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  &__single {
    flex: 0 0 45%;
  }

  &__shipping-options {
    @include unlist;
    display: flex;
    flex-direction: column;
  }

  &__shipping-option {
    display: flex;
    align-items: flex-start;

    &:not(:last-child) {
      @include margin-bottom(map-get($spacers, 6));
    }
  }

  &__shipping-icon {
    flex: 0 0 3rem;
    height: auto;
    @include margin-right(map-get($spacers, 4));
  }

  &__shipping-title {
    @include font-size(map-get($landing-page, 'font-size-lg'));
  }

  &__shipping-description {
    margin: 0;
    font-weight: $font-weight-light;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
    &:after {
      height: 20rem;
    }
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
    background: $yellow;

    // LP Section overwritings
    .landing-page__section-heading {
      @include margin-bottom(map-get($spacers, 6));
    }

    &__duo {
      flex-direction: column;
      @include padding-bottom(map-get($spacers, 6) * 4);
    }

    &__shipping-option {
      flex-direction: column;

      &:not(:last-child) {
        @include margin-bottom(map-get($spacers, 4) * 3);
      }
    }

    &__shipping-icon {
      width: 2rem;
      flex: unset;
      margin-right: unset;
      @include margin-bottom(map-get($spacers, 3));
    }
  }
}
</style>
